<template>
  <div class="chat-auto-page">
    <div class="message-all" :class="message.from === 'me' ? 'message-me' : 'message-other'" v-for="(message, mi) in messageList" :key="mi">
      <div class="message-content-outer">
        <div class="message-content-inner">
          <div class="message-avatar">
            <img class="avatar" v-if="message.from === 'other'" src="..\..\..\src\assets\icon.png" mode="widthFix" width="20" height="20">
          </div>
          <div class="message-item">
            <div class="message-text" v-if="message.text">{{ message.text }}</div>
            <template v-if="message.from === 'other' && message.list0 && message.list0.length">
              <div v-for="(par, indexP) in message.list0" :key="indexP">
                <template v-if="par.type === 'option'">
                  <div class="message-option" @click="optionClick(item)"
                    v-for="(item, index) in par.list" :key="index">
                    <span class="uni-icon" style="font-size: 14px;">&#xe504;</span>
                    {{ item.question }}
                  </div>
                  <!-- <div class="message-option-null" v-if="!par.list.length">
                    > 当前分类暂无数据
                  </div> -->
                </template>
                <template v-if="par.type === 'text'">
                  <div class="message-text"
                    v-for="(item, index) in par.list" :key="index">
                    <!-- {{ item.text }} -->
                    <!-- {{ item.question }} -->
                    <!-- <template v-if="item.list1 && item.list1.length">
                      <div class="message-file" @click="srcFileClick(item1)"
                        v-for="(item1, index) in item.list1" :key="index">
                        {{ item1.title }}
                      </div>
                    </template> -->
                    <template v-if="item.question.indexOf('thinkStart') >= 0 && item.question.indexOf('thinkEnd') >= 0">
                      <span style="color: gray; font-size: 14px;">
                        {{ item.question.split('thinkStart')[1].split('thinkEnd')[0] }}
                      </span>
                      <span v-for="(bItem, bIndex) in item.question.split('thinkStart')[1].split('thinkEnd')[1].split('**')" :key="bIndex"
                        :style="bIndex % 2 === 1 ? 'font-weight: bold;' : ''">
                        {{ bItem }}
                      </span>
                    </template>
                    <template v-else>
                      <span v-for="(bItem, bIndex) in item.question.split('**')" :key="bIndex"
                        :style="bIndex % 2 === 1 ? 'font-weight: bold;' : ''">
                        {{ bItem }}
                      </span>
                    </template>
                  </div>
                </template>
                <template v-if="par.type === 'file'">
                  <div class="message-file" @click="fileClick(item)"
                    v-for="(item, index) in par.list" :key="index">
                    {{ item.title }}
                  </div>
                </template>
                <template v-if="par.type === 'inline'">
                  <template v-for="(item, index) in par.list">
                    <span :key="index" v-if="item.category === '1'" class="message-text">{{item.question}}</span>
                    <!-- <span v-if="item.category === '2'" class="message-inline uni-icon" @click="optionClick(item)" style="font-size: 14px;">&#xe504;</span> -->
                    <span :key="index" v-if="item.category === '2'" class="message-inline" @click="optionClick(item, message)"><u>{{item.question}}</u></span>
                    <span :key="index" v-if="item.category === '3' && message.fileNum > 1" class="message-inline" @click="optionClick(item, message)"><u>{{!message.isShowMoreFile ? item.question : item.question1}}</u></span>
                  </template>
                </template>
                <template v-if="par.type === 'srcFile'">
                  <div :class="{
                    'message-srcFile': index === 0 || (index !== 0 && message.isShowMoreFile),
                    'message-srcFile-hide': index !== 0 && !message.isShowMoreFile
                  }"
                    @click="srcFileClick(item)"
                    v-for="(item, index) in par.list" :key="index">
                    <template v-if="index === 0 || message.isShowMoreFile">
                      <!-- <template v-if="message.isShowMoreFile">{{ index+1 }}.</template> -->
                      {{ item.title }}
                    </template>
                  </div>
                </template>
                <template v-if="par.type === 'picture'">
                  <img @click="copyPicUrl(par.list[0].question)" style="margin-left: 8px;" :src="par.list[0].question" width="90%"><br>
                </template>
                <template v-if="par.type === 'table'">
                  <table class="listTable" width="100%" border="1" align="center">
                    <tr v-for="(item, index) in par.list" :key="index">
                      <td v-for="(itemA, indexA) in item.rowItems" :key="indexA">
                        <el-input disabled v-model="itemA.value"></el-input>
                      </td>
                    </tr>
                  </table>
                  <img @click="copyPicUrl(par.list[0].question)" style="margin-left: 8px;" :src="par.list[0].question" width="90%"><br>
                </template>
              </div>
            </template>
            <div class="message-text" v-if="message.text1">{{ message.text1 }}</div>
          </div>
          <div class="message-avatar">
            <img class="avatar" v-if="message.from === 'me'" src="..\..\..\src\assets\icon.png" mode="widthFix" width="20" height="20">
          </div>
        </div>
      </div>
    </div>
    <div class="look-more" @click="$router.push('/h5download')">查看更多</div>
  </div>
</template>

<script>
import api from '../../../api/index.js'
export default {
  data () {
    return {
      phNum: '',
      myAvatar: '', // 我的头像
      otherAvatar: '',
      messageList: [
        {
          from: 'other',
          text: '',
          type: 'option',
          list: [{
            id: 0,
            question: ''
          }]
        },
        {
          from: 'me',
          text: '',
          type: 'text'
        }
      ], // 聊天消息列表
      clickId: 0,
      loadingFlag: false,
      inputableFlag: true,
      searchKeyword: '',
      bottomId: '',
      numberQA: 0,
      searchWord: '',
      loadingTips: ''
    }
  },
  created () {
    if (this.$route.query.answerId) {
      api.cdAshKetchupAnswerId({
        answerId: this.$route.query.answerId
      }).then(res => {
        if (res.code === 200) {
          // this.crtItem = res.data
          var msgQ = {
            from: 'me',
            text: res.data.listQ,
            type: 'text'
          }
          var msgA = {
            from: 'other',
            isShowMoreFile: false,
            fileNum: 0,
            // text: res.data.text,
            // text1: res.data.text1,
            list0: res.data.listA || []
          }
          msgA.list0.forEach((par, indexP) => {
            switch (par.type) {
              case 0:
                par.type = 'input'
                this.inputableFlag = true
                break
              case 1:
                par.type = 'option'
                // this.inputableFlag = false
                break
              case 2:
                par.type = 'text'
                // par.type = 'file'
                // this.inputableFlag = false
                break
              case 3:
                par.type = 'file'
                // this.inputableFlag = false
                break
              case 4:
                par.type = 'inline'
                // this.inputableFlag = false
                break
              case 5:
                par.type = 'srcFile'
                msgA.fileNum = par.list.length
                // this.inputableFlag = false
                break
              case 6:
                par.type = 'picture'
                // this.inputableFlag = false
                break
              case 7:
                par.type = 'table'
                // this.inputableFlag = false
                break
              default:
                par.type = 'text'
                // this.inputableFlag = false
                break
            }
          })
          this.messageList = [msgQ, msgA]
        }
      })
    }
  },
  methods: {
    copyPicUrl (url) {
      window.open(url)
    },
    optionClick (option, message) {
      // this.clickId = option.id
      // let pusher = {
      //   from: 'me',
      //   text: option.question
      // }
      // let sPath = ''
      switch (option.id) {
        // case 108:
        //   sPath = `/pages/famous/industriesClassification?keyword=${this.searchWord}`
        //   break
        // case 109:
        //   sPath = `/pages/famous/index?keyword=${this.searchWord}&type=0`
        //   break
        // case 2:
        // case 110:
        // case 111:
        //   sPath = `/pages/search/indexFromChat?keyword=${this.searchWord}&type=0`
        //   break
        // case 113:
        //   sPath = `/pages/search/erwupu/index?keyword=${this.searchWord} `
        //   break
        // case 119:
        //   sPath = `/pages/search/qua/index?keyword=${this.searchWord} `
        //   break
        // case 120:
        //   uni.navigateBack()
        //   break
        case 122:
          message.isShowMoreFile = !message.isShowMoreFile
          console.log('isShowMoreFile', message.isShowMoreFile)
          // this.messageList.push()
          break
        // case 180:
        //   this.shareAnswer(option.answerId, option.answerQ)
        //   break
        // // case 180:
        // //   this.feedback(option.answerId, option.answerQ)
        // //   break
        // default:
        //   this.messageList.push(pusher)
        //   this.getRepeat(option.id, this.searchWord)
        //   break
      }
      // if (sPath) {
      //   uni.navigateTo({
      //     url: `${sPath}`
      //   })
      // }
      // this.getRepeat(option.id)
      // switch (option.id) {
      //   case 8:
      //   case 9:
      //   case 10:
      //   case 11:
      //   case 12: // 环评-其他问题
      //   case 13: // 环评-二污普
      //     this.inputableFlag = true
      //     this.messageList.push({
      //       from: 'other',
      //       text: '您想提问的内容是？',
      //       type: 'text'
      //     })
      //     this.bottomId = ''
      //     this.$nextTick(() => {
      //       this.bottomId = 'bottomId'
      //     })
      //     break
      //   default:
      //     this.getRepeat(option.id)
      //     break
      // }
    },
    srcFileClick (item) {
      this.$router.push('/h5download')
    }
  }
}
</script>

<style lang="scss">
  .chat-auto-page {
    // height: 100%;
    background-color: #efecf1;
    width: 100%;
    .message-all {
      width: calc(100% - 8px * 2);
      display: flex;
      padding: 8px 8px 0;
    }
    .message-other {
      display: inline-block;
      text-align: left;
      .message-item {
        border-radius: 0 16px 16px 16px;
        background-color: #f4f5f6;
      }
    }
    .message-me {
      display: inline-block;
      text-align: right;
      .message-item {
        border-radius: 16px 0 16px 16px;
        background-color: #39b92e;
        color: #efecf1;
        text-align: left;
      }
    }
    .message-content-outer {
      display: inline-block;
      max-width: 100%;
    }
    .message-content-inner {
      // max-width: calc(100% - 80px);
      max-width: 100%;
      font-size: 16px;
      white-space: pre-line;
      display: flex;
      .message-avatar {
        min-width: 36px;
        height: 36px;
        border-radius: 8px;
        .avatar {
          width: 36px;
          height: 36px;
          border-radius: 8px;
        }
      }
      .message-item {
        // display: inline-block;
        // max-width: calc(100% - 114px);
        max-width: calc(100% - 108px);
        margin: 0 8px;
        width: fit-content;
        border: 1px #ccc solid;
        // background-color: #39b92e;
        padding: 6px 12px;
        line-height: 24px;
        .message-file {
          color: #409eff;
        }
        .message-option {
          color: #409eff;
        }
        .message-option-null {
          color: #83889a;
        }
        .message-inline {
          color: #409eff;
        }
        .message-srcFile {
          color: #409eff;
          height: 24px;
          max-width: calc(100vw - (8px + 36px + 8px + 1px + 12px) * 2);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .message-srcFile-hide {
          display: none;
        }
      }
    }
    .look-more {
      text-align: center;
      color: #409eff;
      background: #fff;
      padding: 16px;
      font-size: 20px;
      margin-top: 16px;
    }
  }
</style>
